import React from 'react';
import PropTypes from 'prop-types';

import UserListItem from './UserListItem';

const UserListItems = ({
  handleSelection,
  items = [],
  selectedItems = [],
  handleExpendTree,
  position,
}) => {
  const renderList = () =>
    items.map(item => {
      item.selected =
        selectedItems &&
        selectedItems.indexOf(item.id) >= 0;
      return (
        <UserListItem
          key={item.id}
          {...item}
          handleSelection={handleSelection}
          listid={item.id}
          handleExpendTree={handleExpendTree}
          position={position}
        />
      );
    });

  return (
    <div className="multi-select-list">
      <ul
        className="vertical dropdown menu user-select-none"
        data-dropdown-menu
      >
        {renderList()}
      </ul>
    </div>
  );
};

UserListItems.propTypes = {
  handleSelection: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItems: PropTypes.instanceOf(Array),
  handleExpendTree: PropTypes.func,
  position: PropTypes.string,
};

export default UserListItems;
